(function () {
  var desktop = window.matchMedia('(min-width: 990px)');

  // Header: transparent over the hero, solid after scrolling
  var header = document.querySelector('.bv-header--overlay');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-solid', window.scrollY > 80); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Mobile menu drawer
  var drawer = document.getElementById('bv-drawer');
  document.querySelectorAll('[data-bv-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      document.documentElement.style.overflow = 'hidden';
      var close = drawer.querySelector('[data-bv-menu-close]');
      if (close) close.focus();
    });
  });
  document.querySelectorAll('[data-bv-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      document.documentElement.style.overflow = '';
      var open = document.querySelector('[data-bv-menu-open]');
      if (open) open.focus();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      drawer.querySelector('[data-bv-menu-close]').click();
    }
  });

  // Hero film pause / play
  document.querySelectorAll('[data-bv-video-toggle]').forEach(function (btn) {
    var video = btn.closest('.bv-hero').querySelector('video');
    if (!video) { btn.hidden = true; return; }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.pause(); }
    var sync = function () {
      var paused = video.paused;
      btn.setAttribute('aria-label', paused ? 'Play film' : 'Pause film');
      btn.querySelector('.bv-i-pause').style.display = paused ? 'none' : '';
      btn.querySelector('.bv-i-play').style.display = paused ? '' : 'none';
    };
    btn.addEventListener('click', function () { video.paused ? video.play() : video.pause(); sync(); });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();
  });

  // Carousels and swipe rows: arrows + progress bar
  document.querySelectorAll('[data-bv-scroller]').forEach(function (row) {
    var root = row.closest('[data-bv-carousel]') || row.parentElement;
    var bar = root.querySelector('.bv-progress span');
    var prev = root.querySelector('[data-bv-prev]');
    var next = root.querySelector('[data-bv-next]');
    var update = function () {
      var max = row.scrollWidth - row.clientWidth;
      if (bar) {
        var w = row.scrollWidth > 0 ? (row.clientWidth / row.scrollWidth) * 100 : 100;
        bar.style.width = Math.min(100, w) + '%';
        bar.style.left = (row.scrollWidth > 0 ? (row.scrollLeft / row.scrollWidth) * 100 : 0) + '%';
      }
      if (prev) prev.disabled = row.scrollLeft <= 2;
      if (next) next.disabled = row.scrollLeft >= max - 2;
    };
    var page = function (dir) {
      var card = row.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 24) : row.clientWidth;
      var perView = Math.max(1, Math.round(row.clientWidth / step));
      row.scrollBy({ left: dir * step * perView, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    row.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); page(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); page(-1); }
    });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });


  // Collection image menu: filters the grid by words in the product name ("-word" excludes)
  var cats = document.querySelector('[data-bv-cats]');
  if (cats && cats.querySelector('button.bv-cat[data-bv-cat]:not([data-bv-cat=""])')) {
    var current = '';
    var grid = document.getElementById('product-grid');
    var parse = function (str) {
      var inc = [], exc = [];
      (str || '').split(',').forEach(function (w) {
        w = w.trim().toLowerCase();
        if (!w) return;
        if (w.charAt(0) === '-') { if (w.length > 1) exc.push(w.slice(1).trim()); } else inc.push(w);
      });
      return { inc: inc, exc: exc };
    };
    var matches = function (title, rule) {
      if (rule.exc.some(function (w) { return title.indexOf(w) !== -1; })) return false;
      return !rule.inc.length || rule.inc.some(function (w) { return title.indexOf(w) !== -1; });
    };
    var titleOf = function (item) {
      var h = item.querySelector('.card__heading');
      return h ? h.textContent.toLowerCase().trim() : '';
    };
    var items = function () { return grid ? Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid__item')) : []; };
    var recount = function () {
      var all = items();
      cats.querySelectorAll('button.bv-cat').forEach(function (btn) {
        var rule = parse(btn.getAttribute('data-bv-cat'));
        var n = all.filter(function (it) { return matches(titleOf(it), rule); }).length;
        var c = btn.querySelector('[data-bv-count]');
        if (c) c.textContent = n;
        var li = btn.closest('[data-bv-cat-item]');
        if (li) li.hidden = n === 0;
      });
      var row = cats.querySelector('[data-bv-scroller]');
      if (row) row.dispatchEvent(new Event('scroll'));
    };
    var apply = function () {
      var rule = parse(current);
      var shown = 0;
      items().forEach(function (item) {
        var ok = !current || matches(titleOf(item), rule);
        item.classList.toggle('bv-hidden-by-cat', !ok);
        if (ok) shown++;
      });
      document.querySelectorAll('.pagination-wrapper').forEach(function (p) { p.style.display = current ? 'none' : ''; });
      ['ProductCountDesktop', 'ProductCount'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el && current) el.textContent = shown + (shown === 1 ? ' product' : ' products');
      });
    };
    // Load the other pages of the collection so filters and counts cover every product
    var loaded = Promise.resolve();
    var pageLinks = document.querySelectorAll('.pagination-wrapper a[href*="page="]');
    if (grid && pageLinks.length) {
      var max = 1;
      pageLinks.forEach(function (a) { var m = a.href.match(/page=(\d+)/); if (m) max = Math.max(max, parseInt(m[1], 10)); });
      var cur = parseInt((location.search.match(/page=(\d+)/) || [0, 1])[1], 10);
      var urls = [];
      for (var i = 1; i <= max; i++) if (i !== cur) { var u = new URL(location.href); u.searchParams.set('page', i); u.hash = ''; urls.push(u.toString()); }
      loaded = Promise.all(urls.map(function (u) { return fetch(u).then(function (r) { return r.text(); }).catch(function () { return ''; }); }))
        .then(function (pages) {
          pages.forEach(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            doc.querySelectorAll('#product-grid > .grid__item').forEach(function (it) {
              it.classList.add('bv-extra-page');
              grid.appendChild(document.importNode(it, true));
            });
          });
        });
    }
    var style = document.createElement('style');
    style.textContent = '#product-grid > .bv-extra-page { display: none; } [data-bv-filtering] #product-grid > .bv-extra-page:not(.bv-hidden-by-cat) { display: block; }';
    document.head.appendChild(style);
    var select = function (btn, push) {
      cats.querySelectorAll('button.bv-cat').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      current = btn.getAttribute('data-bv-cat') || '';
      document.documentElement.toggleAttribute('data-bv-filtering', !!current);
      loaded.then(apply);
      if (push) {
        var slug = btn.getAttribute('data-bv-slug');
        history.replaceState(null, '', slug ? '#' + slug : location.pathname + location.search);
      }
    };
    cats.querySelectorAll('button.bv-cat').forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn, true); });
    });
    loaded.then(function () {
      recount();
      if (location.hash) {
        var fromHash = cats.querySelector('[data-bv-slug="' + location.hash.slice(1) + '"]');
        if (fromHash) select(fromHash, false);
      }
    });
    var container = document.getElementById('ProductGridContainer');
    if (container) new MutationObserver(function (muts) {
      if (muts.some(function (m) { return Array.prototype.some.call(m.addedNodes, function (n) { return n.id === 'product-grid' || (n.querySelector && n.querySelector('#product-grid')); }); })) {
        grid = document.getElementById('product-grid'); if (current) apply();
      }
    }).observe(container, { childList: true, subtree: true });
  }


  // Photos on the cream / grey backdrops: grey studio backgrounds are lifted to white so they blend into the
  // backdrop. Only grey photos are brightened (by exactly the amount needed); pure white photos are left alone,
  // because brightening white makes it brighter than white on iPhones and it then shows as a white box.
  var bvLiftCache = {};
  var bvLevel = function (url) {
    if (bvLiftCache[url]) return bvLiftCache[url];
    var small = url.replace(/([?&])width=\d+/, '$1width=80');
    if (small === url) small = url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=80';
    bvLiftCache[url] = fetch(small, { mode: 'cors' })
      .then(function (r) { return r.blob(); })
      .then(function (b) { return createImageBitmap(b); })
      .then(function (bmp) {
        var c = document.createElement('canvas'); c.width = bmp.width; c.height = bmp.height;
        var x = c.getContext('2d'); x.drawImage(bmp, 0, 0);
        var w = bmp.width, h = bmp.height, pts = [[1, 1], [w - 2, 1], [1, h - 2], [w - 2, h - 2], [Math.floor(w / 2), 1], [Math.floor(w / 2), h - 2]];
        var vals = pts.map(function (p) { var d = x.getImageData(p[0], p[1], 1, 1).data; return Math.min(d[0], d[1], d[2]); }).sort(function (a, b) { return a - b; });
        return vals[Math.floor(vals.length / 2)];
      })
      .catch(function () { return 255; });
    return bvLiftCache[url];
  };
  var bvLift = function (img) {
    if (img.dataset.bvLift) return;
    if (getComputedStyle(img).mixBlendMode !== 'multiply') return;
    var src = img.currentSrc || img.src;
    if (!src || src.indexOf('data:') === 0 || src.indexOf('.svg') !== -1) {
      img.addEventListener('load', function () { bvLift(img); }, { once: true });
      return;
    }
    img.dataset.bvLift = '1';
    bvLevel(src).then(function (v) {
      if (v >= 200 && v < 251) img.style.filter = 'brightness(' + (254 / v).toFixed(3) + ')';
    });
  };
  var bvLiftAll = function (root) { (root || document).querySelectorAll('img').forEach(bvLift); };
  bvLiftAll();
  new MutationObserver(function (muts) {
    muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.tagName === 'IMG') bvLift(n); else bvLiftAll(n); } }); });
  }).observe(document.body, { childList: true, subtree: true });

  // Footer columns: always open on desktop, accordions on mobile
  var cols = document.querySelectorAll('.bv-footer__col');
  var setCols = function () {
    cols.forEach(function (d) { if (desktop.matches) { d.setAttribute('open', ''); } else { d.removeAttribute('open'); } });
  };
  setCols();
  desktop.addEventListener('change', setCols);
  cols.forEach(function (d) {
    d.querySelector('summary').addEventListener('click', function (e) { if (desktop.matches) e.preventDefault(); });
  });
})();
